import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M5 11h14v2H5zm-2 4h14v2H3zm4-8h14v2H7z"
}), 'ClearAllTwoTone');